import { mutate } from 'swr';
import actions from '../../actions';
import { API_PATHS } from '../../../utils/constants';

export default {
  [actions.token.created]: ({ token, session: { id } }) =>
    mutate(`${API_PATHS.TOKENS}/${id}`, token),
};
